import createIcon from '../../createIcon';

/**
 * @component @name BatteryUnknown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNjcgNEgxNFYySDEwVjRIOC4zM0M3LjYgNCA3IDQuNiA3IDUuMzNWMjAuNjZDNyAyMS40IDcuNiAyMiA4LjMzIDIySDE1LjY2QzE2LjQgMjIgMTcgMjEuNCAxNyAyMC42N1Y1LjMzQzE3IDQuNiAxNi40IDQgMTUuNjcgNFpNMTIuOTUgMTcuOTVIMTEuMDVWMTYuMDVIMTIuOTVWMTcuOTVaTTE0LjMgMTIuNjlDMTQuMyAxMi42OSAxMy45MiAxMy4xMSAxMy42MyAxMy40QzEzLjE1IDEzLjg4IDEyLjggMTQuNTUgMTIuOCAxNUgxMS4yQzExLjIgMTQuMTcgMTEuNjYgMTMuNDggMTIuMTMgMTNMMTMuMDYgMTIuMDZDMTMuMzMgMTEuNzkgMTMuNSAxMS40MSAxMy41IDExQzEzLjUgMTAuMTcgMTIuODMgOS41IDEyIDkuNUMxMS4xNyA5LjUgMTAuNSAxMC4xNyAxMC41IDExSDlDOSA5LjM0IDEwLjM0IDggMTIgOEMxMy42NiA4IDE1IDkuMzQgMTUgMTFDMTUgMTEuNjYgMTQuNzMgMTIuMjYgMTQuMyAxMi42OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BatteryUnknown = createIcon('BatteryUnknown', [
  [
    'path',
    {
      d: 'M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM12.95 17.95H11.05V16.05H12.95V17.95ZM14.3 12.69C14.3 12.69 13.92 13.11 13.63 13.4C13.15 13.88 12.8 14.55 12.8 15H11.2C11.2 14.17 11.66 13.48 12.13 13L13.06 12.06C13.33 11.79 13.5 11.41 13.5 11C13.5 10.17 12.83 9.5 12 9.5C11.17 9.5 10.5 10.17 10.5 11H9C9 9.34 10.34 8 12 8C13.66 8 15 9.34 15 11C15 11.66 14.73 12.26 14.3 12.69Z',
      key: '19nddl',
    },
  ],
]);

export default BatteryUnknown;
